import React, { memo } from 'react';
export function MethodSection() {
  const items = [{
    title: 'Contexto productivo primero.',
    desc: 'El técnico no memoriza definiciones. Resuelve problemas reales. Cada módulo parte de una situación concreta de granja antes de desarrollar el concepto.'
  }, {
    title: 'Especies y sistemas reales.',
    desc: 'Trucha en zonas frías, tilapia en el trópico, camarón en la costa, cachama en ríos cálidos. El material que tus alumnos reconocen porque es lo que van a manejar en el campo.'
  }, {
    title: 'Del aula al campo en cada sesión.',
    desc: 'Cada módulo incluye actividades aplicables al laboratorio, a la visita de campo o al aula con simulación. Ninguna clase termina solo con teoría.'
  }];
  return <section className="py-9 px-4 bg-brand-creamAlt border-y border-brand-line" data-id="element-114">
      <div className="max-w-4xl mx-auto text-center" data-id="element-115">
        <p className="orange-text font-display font-bold uppercase text-sm tracking-widest mb-2" data-id="element-116">
          ✨ El Método
        </p>
        <h2 className="text-3xl md:text-5xl font-display font-bold uppercase leading-tight mb-3 text-white" data-id="element-117">
          "Técnico <span className="orange-text" data-id="element-118">Aplicado</span>"
        </h2>
        <p className="text-base md:text-lg text-brand-ink font-medium max-w-2xl mx-auto mb-6 leading-snug" data-id="element-119">
          Cada tomo construye competencias sobre competencias — como se aprende
          a producir en el mundo real, pero traducido al aula de formación
          técnica.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-120">
          {items.map((it, i) => <div key={i} className="bg-brand-paper border border-brand-line border-l-4 border-l-brand-orange rounded-lg p-4 text-left" data-id="element-121">
              <span className="text-2xl mb-2 inline-block" data-id="element-122">📌</span>
              <h3 className="font-display text-lg md:text-xl text-white uppercase font-bold mb-1 leading-tight" data-id="element-123">
                {it.title}
              </h3>
              <p className="text-sm text-brand-mute leading-snug font-medium" data-id="element-124">
                {it.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}